module.exports = __webpack_public_path__ + "static/img/s12.2b655a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/s12.png
// module id = BAmv
// module chunks = 0